import { Reducer } from 'redux';
import { LOCATION_CHANGE, LocationChangeAction } from 'connected-react-router';

import { TypesLayout, ActionsLayout } from 'core/redux/actions/lyaout/type';
import { LangValueType } from 'core/types';
import { ILayoutState } from './type';

import SETTINGS from 'core/settings';

export const layoutState: ILayoutState = {
  redirect: {
    url: null,
  },
  loading: new Set(),
  modalLoading: new Set(),
  isSuccess: false,
  message: null,
  notifications: [],
  languagePath: '',
  language: LangValueType.ru,
  withoutLanguagePath: '',
  layoutInfo: {
    header: {
      menu: [],
      contacts: {},
      stocks_count: 0,
    },
    footer: { menu: [], contacts: {} },
  },
  alerts: [],
  alertsUniversal: [],
};

const layout: Reducer<ILayoutState, ActionsLayout | LocationChangeAction> = (
  state = layoutState,
  action
) => {
  switch (action.type) {
    case TypesLayout.REDIRECT:
      return {
        ...state,
        redirect: { ...state.redirect, url: action.url, state: action.state },
      };
    case LOCATION_CHANGE:
      const langReg = SETTINGS.displayedLanguages
        .filter((lang) => lang !== SETTINGS.excludeLanguage)
        .join('|');
      const match = action.payload.location.pathname.match(new RegExp(`^(/(${langReg}))?(/.*)?$`));
      return {
        ...state,
        redirect: layoutState.redirect,
        languagePath: match && match[1] ? match[1] : '',
        language:
          match && match[2]
            ? (match[2] as LangValueType)
            : SETTINGS.excludeLanguage || SETTINGS.defaultLanguage,
        withoutLanguagePath: match && match[3] ? match[3] : '/',
        // alerts: layoutState.alerts,
      };
    case TypesLayout.PROGRESS_START:
      if (action.isModal) {
        state.modalLoading.add(action.url);
      } else {
        state.loading.add(action.url);
      }
      return { ...state };
    case TypesLayout.PROGRESS_END:
      if (action.isModal) {
        state.modalLoading.delete(action.url);
      } else {
        state.loading.delete(action.url);
      }
      return { ...state };
    // case TypesLayout.SET_IS_SUCCESS:
    //   return {
    //     ...state,
    //     isSuccess: action.isSuccess || false,
    //   };
    // case TypesLayout.SET_MESSAGE:
    //   return {
    //     ...state,
    //     message: action.message || null,
    //   };
    case TypesLayout.ENQUEUE_SNACKBAR:
      return {
        ...state,
        notifications: [
          ...state.notifications,
          {
            ...action.notification,
          },
        ],
      };
    case TypesLayout.CLOSE_SNACKBAR:
      return {
        ...state,
        notifications: state.notifications.map((notification) =>
          action.dismissAll || notification.key === action.key
            ? { ...notification, dismissed: true }
            : { ...notification }
        ),
      };
    case TypesLayout.REMOVE_SNACKBAR:
      return {
        ...state,
        notifications: state.notifications.filter(
          (notification) => notification.key !== action.key
        ),
      };

    case TypesLayout.GET_LAYOUT_INFO_SUCCESS:
      return {
        ...state,
        layoutInfo: {
          header: action.data.header || layoutState.layoutInfo.header,
          footer: action.data.footer || layoutState.layoutInfo.footer,
        },
      };

    case TypesLayout.SET_ALERT:
      return { ...state, alerts: [...state.alerts, { ...action.alert, id: Date.now() }] };

    case TypesLayout.REMOVE_ALERT:
      return { ...state, alerts: state.alerts.filter((alert) => alert.id !== action.alertId) };

    default:
      return state;
  }
};

export default layout;
